module.exports = __webpack_public_path__ + "static/media/carousel-img03.7fefd8b2.png";